// SEO utility functions
export const getSiteUrl = (): string => {
  return import.meta.env.VITE_SITE_URL || 'https://elprat.justclean.es';
};

export const updateMetaTags = (config: {
  title: string;
  description: string;
  keywords?: string;
  path?: string;
  ogImage?: string;
}) => {
  const siteUrl = getSiteUrl();
  const fullUrl = config.path ? `${siteUrl}${config.path}` : siteUrl;

  // Update title
  document.title = config.title;

  // Update or create meta tags
  const updateOrCreateMeta = (selector: string, attribute: string, value: string) => {
    let meta = document.querySelector(selector);
    if (!meta) {
      meta = document.createElement('meta');
      if (selector.includes('property')) {
        meta.setAttribute('property', selector.match(/property="([^"]+)"/)?.[1] || '');
      } else {
        meta.setAttribute('name', selector.match(/name="([^"]+)"/)?.[1] || '');
      }
      document.head.appendChild(meta);
    }
    meta.setAttribute(attribute, value);
  };

  // Update canonical
  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    document.head.appendChild(canonical);
  }
  canonical.setAttribute('href', fullUrl);

  // Update meta description
  updateOrCreateMeta('meta[name="description"]', 'content', config.description);

  // Update keywords if provided
  if (config.keywords) {
    updateOrCreateMeta('meta[name="keywords"]', 'content', config.keywords);
  }

  // Update Open Graph tags
  updateOrCreateMeta('meta[property="og:title"]', 'content', config.title);
  updateOrCreateMeta('meta[property="og:description"]', 'content', config.description);
  updateOrCreateMeta('meta[property="og:url"]', 'content', fullUrl);

  if (config.ogImage) {
    updateOrCreateMeta('meta[property="og:image"]', 'content', config.ogImage);
  }

  // Update last-modified
  updateOrCreateMeta('meta[name="last-modified"]', 'content', new Date().toISOString().split('T')[0]);
};

export const addStructuredData = (data: object) => {
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.text = JSON.stringify(data);
  document.head.appendChild(script);
  return script;
};